import { createStore } from 'vuex'
import { getCurrentAdmin, loginAdmin } from '@/services/auth'

const savedToken = sessionStorage.getItem('adminToken') || ''
localStorage.removeItem('adminToken')
localStorage.removeItem('token')

export default createStore({
  state: {
    isAuthenticated: Boolean(savedToken),
    token: savedToken,
    user: null,
  },
  mutations: {
    setAuthenticated(state, isAuthenticated) {
      state.isAuthenticated = isAuthenticated
    },
    setAuth(state, { token, user }) {
      state.token = token
      state.user = user
      state.isAuthenticated = Boolean(token)
      if (token) {
        sessionStorage.setItem('adminToken', token)
        localStorage.removeItem('adminToken')
        localStorage.removeItem('token')
      }
    },
    setUser(state, user) {
      state.user = user
      state.isAuthenticated = Boolean(state.token)
    },
    clearAuth(state) {
      state.token = ''
      state.user = null
      state.isAuthenticated = false
      sessionStorage.removeItem('adminToken')
      localStorage.removeItem('adminToken')
      localStorage.removeItem('token')
    },
  },
  actions: {
    async login({ commit }, credentials) {
      const result = await loginAdmin(credentials)
      commit('setAuth', { token: result.token, user: result.user })
      return result.user
    },
    async fetchCurrentAdmin({ commit }) {
      const user = await getCurrentAdmin()
      commit('setUser', user)
      return user
    },
    logout({ commit }) {
      commit('clearAuth')
    },
  },
  getters: {
    isAuthenticated: (state) => state.isAuthenticated,
    currentAdmin: (state) => state.user,
    adminToken: (state) => state.token,
  },
})
